import React from 'react';

import {Component} from './component';
import routes from '../routes';
import Link from './Link';
import Api from '../api';
import {ArrowRight} from './icons/index.js';
import emptyPic from './emptyPic';

class SignOutLink extends Component {

  signOut = async (e) => {
    e.preventDefault();
    await Api.signout();
    this.props.user.set(null);
    routes.navigateTo('/');
  };

  renderLoaded() {
    return (
      <a className='Link' href='#signout' onClick={this.signOut}>
        Выйти
      </a>
    );
  }
}

export default class UserTools extends Component {

  renderLoaded({user, request}) {
    // cannot use `fullPath` because 4game auth does not handle
    // query string params properly
    const returnUrl = encodeURIComponent(request.get('baseUrl').replace(/\/+$/, ''));
    const forgameUrl = (/.*\.test4game\.com/g).test(request.get('baseUrl')) ? 'ru-www.test4game.com' : 'ru-new.4game.com';

    if (user.hasData()) {
      return <div className='UserTools'>
        <div className='UserTools-NicknameSignInOut'>
          <div className='UserTools-Nickname'>
            <Link name='playerDetails' params={{id: user.get('id')}}>
              {user.get('nickname')}
            </Link>
          </div>
          <div className='UserTools-SignInOut'>
            <div className='UserTools-SignIn'>
              <Link className='UserTools-profile' name='playerDetails'
                    params={{id: user.get('id')}}>
                Профиль
              </Link>
            </div>
            <div className='UserTools-SignOut'>
              <SignOutLink user={user} />
            </div>
          </div>
        </div>
        <div className='UserTools-Avatar'>
          {user.get('image') &&
            <Link name='playerDetails' params={{id: user.get('id')}}>
              <img src={user.get('image') ? `${user.get('image')}?crop=1&w=40&h=40` : emptyPic} className='UserTools-Image' />
            </Link>
          }
        </div>
      </div>;
    } else {
      return (
        <div className='UserTools'>
          <a href={`https://${forgameUrl}/auth/?clientId=arena4game&redirectTo=${returnUrl}`}>
            Войти
          </a>
          <ArrowRight className='UserTools-ArrowRight' />
        </div>
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/UserTools.js